import RadarPlugin from '../../kastjs/radar';
import { aopFactory } from './aop';

export const radarPluginAOP = aopFactory(RadarPlugin, {});
